<template>
    <svg :class="className" width="9" height="5" viewBox="0 0 9 5">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.70472 4.68313C3.9177 4.8877 4.19891 5 4.50037
            5C4.80109 5 5.0838 4.8877 5.29528 4.68313L8.78009 1.23404C9.0733 0.951504 9.0733 0.494439 8.78009
            0.211902C8.48763 -0.0706341 8.01294 -0.0706341 7.71972 0.211902L4.50037 3.40564L1.28028
            0.211902C0.987064 -0.0706341 0.513123 -0.0706341 0.21991 0.211902C-0.0733033 0.494439 -0.0733033
            0.951504 0.21991 1.23404L3.70472 4.68313Z">
        </path>
    </svg>
</template>

<script>
export default {props: ['className']};
</script>
